<script>
  import SvelteMarkdown from "svelte-markdown";

  import { themeStore } from "$lib/gpu-glossary";

  export let href;
  export let text;
  export let figCaptionSize = "lg";

  $: isItalic = text.startsWith("_") && text.endsWith("_");
  $: renderedText = isItalic ? text.slice(1, -1) : text;

  $: isExternal = href.startsWith("http");

  $: arrowSize = figCaptionSize === "sm" ? 8 : 10;
</script>

<a
  {href}
  target={isExternal ? "_blank" : undefined}
  rel={isExternal ? "noopener noreferrer" : undefined}
  style:font-style={isItalic ? "italic" : "normal"}
  style:background-color={$themeStore.primary[20]}
  class="inline px-1 -mx-1 group"
>
  <span class="inline group-hover:underline">
    <SvelteMarkdown source={renderedText} isInline />
  </span>

  {#if isExternal}
    <svg
      class="inline mb-1"
      style:margin-bottom={figCaptionSize === "sm" ? "0.1em" : "0.2em"}
      width={arrowSize}
      height={arrowSize}
      viewBox={`0 0 ${arrowSize} ${arrowSize}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.42857 10.5V9.78572H2.14285V9.07139H2.85714V8.35713H3.57144V7.64287H4.2857V6.92854H4.99997V6.21427H5.7143V5.50001H6.42856V4.78569H7.14282V4.07142H7.85715V3.35713H8.57141V7.64287H10V0.5H2.85714V1.92856H7.14282V2.64285H6.42856V3.35713H5.7143V4.07142H4.99997V4.78569H4.2857V5.50001H3.57144V6.21427H2.85714V6.92854H2.14285V7.64287H1.42857V8.35713H0.714288V9.07139H0V10.5H1.42857Z"
        fill="currentColor"
        transform={`scale(${arrowSize / 10})`}
      />
    </svg>
  {:else}
    <!-- This is a hack to get the inlining and text-wrapping to work -->
    <span class="inline-block -ml-2"></span>
  {/if}
</a>

<style>
  a:hover svg {
    transform: scale(1.2);
    transition: transform 0.2s ease;
  }
</style>
